import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

const BaseWrap = styled.div`
    position: absolute;
    top: 0;
    left: calc(100% + ${toRem(20)});
    width: min(${toRem(392)}, 50vw);
    height: max-content;
    border-radius: ${toRem(16)};
    background: ${COLORS.BG.PAGE_FILLED};
    overflow: hidden;
    z-index: 10;

    display: flex;
    flex-direction: column;
    gap: ${toRem(4)};
`;

export const AnimatedWrap = styled(BaseWrap)`
    &.hud-slide-enter {
        opacity: 0;
        transform: translateX(-12px);
    }
    &.hud-slide-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: opacity 200ms ease, transform 200ms ease;
    }
    &.hud-slide-exit {
        opacity: 1;
        transform: translateX(0);
    }
    &.hud-slide-exit-active {
        opacity: 0;
        transform: translateX(-12px);
        transition: opacity 150ms ease, transform 150ms ease;
    }
`;

export const OurServicesTitle = styled.div`
  background-color: ${COLORS.BG.PAGE_FILLED};
  display: flex;
  align-items: center;
  gap: ${toRem(12)};
  justify-content: space-between;
  width: 100%;
  padding: ${toRem(16)};
  --button-s-padding-left: ${toRem(2)};
  --button-s-padding-right: ${toRem(2)};

  h3 {
    font-weight: 700;
    font-size: ${toRem(16)};
    line-height: ${24 / 16};
  }
`

export const OurServicesBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
  padding: ${toRem(16)};

  max-height: ${toRem(300)};
  overflow: clip auto;

  a {
    background-color: ${COLORS.BG.PAGE};
    border-radius: ${toRem(16)};
    display: flex;
    align-items: center;
    gap: ${toRem(12)};
    padding: ${toRem(16)};
    transition: background-color 0.3s ease 0s;
    color: var(--fg-soft, rgba(16, 24, 40, 0.75));
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
      
      @media (any-hover: hover){
      &:hover{
        background-color: ${COLORS.NEUTRAL.CONTAINER_SOFT};
      }
    }
  }
`